export default {
      id: "icon--emblem-text-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--emblem-text-usage",
      toString: function () {
        return this.url;
      }
    }